import { CookieAttributes } from './cookie_lib/cookie_lib';

export enum EBrowserStorageType {
  COOKIES = 'ck',
  GLOBAL_STATE = 'gs',
  LOCALSTORAGE = 'ls',
  SESSIONSTORAGE = 'ssnst',
}

export type SmSetValueFunction = (params: SmSetValueFunctionParams) => {
  success: boolean;
};

export type SmGetValueFunction = (
  params: SmGetValueFunctionParams,
) => SmGetValueFunctionReturnValue;

export type SmGetValueFunctionReturnValue = SmGetFailure | SmGetSuccess;

export type SmSetValueFunctionParams =
  | CookiesSetValueParams
  | GenericSetValueParams
  | GlobalStateSetValueParams;

export type CookiesSetValueParams = {
  item_key: string;
  item_value: string;
  provider_options?: CookieAttributes;
  storage_provider: EBrowserStorageType.COOKIES;
};

export type SmGetValueFunctionParams =
  | SmGetValueGenericFunctionParams
  | SmGetValueGlobalStateFunctionParams;

export type SmGetValueGenericFunctionParams = {
  default: string;
  item_key: string;
  storage_provider: Exclude<
    EBrowserStorageType,
    EBrowserStorageType.GLOBAL_STATE
  >;
};
export type SmGetValueGlobalStateFunctionParams = {
  default: any;
  item_key: string;
  storage_provider: EBrowserStorageType.GLOBAL_STATE;
};

type SmGetSuccess = {
  item_value: any;
  success: true;
};

type SmGetFailure = {
  err_msg: string;
  item_value: any;
  success: false;
};
type GlobalStateSetValueParams = {
  item_key: string;
  item_value: any;
  storage_provider: EBrowserStorageType.GLOBAL_STATE;
};

type GenericSetValueParams = {
  item_key: string;
  item_value: string;
  storage_provider: Exclude<
    EBrowserStorageType,
    EBrowserStorageType.COOKIES | EBrowserStorageType.GLOBAL_STATE
  >;
};
